import { render, staticRenderFns } from "./bulma_calendar.vue?vue&type=template&id=74afac8c&scoped=true&lang=html"
import script from "./bulma_calendar.vue?vue&type=script&lang=js"
export * from "./bulma_calendar.vue?vue&type=script&lang=js"
import style0 from "./bulma_calendar.vue?vue&type=style&index=0&id=74afac8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74afac8c",
  null
  
)

export default component.exports